export default "__VITE_ASSET__a1246684__"